
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ 'navLinks.direitosDeveresPassageiros' | translate}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0" *ngIf="direitosDeveresPassageiros.length > 0">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-12">
          <p [innerHTML]="direitosDeveresPassageiros"></p>
        </div>
      </div>
    </div>
  </section>
</main>

